export const DEFAULT_TAB_SEARCH_PARAM = "tab";

export const DEFAULT_SX = {
  ".MuiTabs-flexContainer": { alignItems: "center" },
};

export const SIZE_SMALL_SX = {
  minHeight: "32px",
  "& .MuiTab-root": {
    fontWeight: 400,
    minHeight: "32px",
    padding: "4px 10px",
    minWidth: 0,
    textTransform: "capitalize",
  },
};
